"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[617],{

/***/ 39425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ClerkDocsLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8395);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var _lib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58038);





function ClerkDocsLogo() {
    const logo = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .useColorModeValue */ .ff)("/images/clerk-logomark-light.svg", "/images/clerk-logomark-dark.svg");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        legacyBehavior: true,
        href: _lib__WEBPACK_IMPORTED_MODULE_4__/* .URLS.docs */ .ns.docs,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, {
            as: "a",
            align: "center",
            display: "inline-flex",
            my: 4,
            gap: 3,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: logo,
                    alt: "Clerk logo",
                    height: "24",
                    width: "24"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                    textStyle: "xl-medium",
                    color: "var(--primaryTextColor)",
                    children: "Clerk Docs"
                })
            ]
        })
    });
}


/***/ }),

/***/ 77248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DynamicHeroIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83319);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2905);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92777);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9014);




const DynamicHeroIcon = (param)=>{
    let { icon , className ="" , weight ="solid"  } = param;
    // eslint-disable-next-line
    const Icon = // @ts-ignore
    weight === "solid" ? _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__[icon] : _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__[icon];
    if (!icon || !Icon) {
        const FallbackIcon = weight === "solid" ? _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FallbackIcon, {
            "aria-hidden": "true",
            className: className
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
            "aria-hidden": "true",
            className: className
        })
    });
};
DynamicHeroIcon.defaultProps = {
    className: undefined,
    weight: undefined
};


/***/ }),

/***/ 34507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ RocketIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function RocketIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.8767 15.5158C19.8445 12.0469 22.8471 5.26536 21.0935 3.51175C19.3399 1.75814 12.5583 4.76075 9.08943 8.72856C6.8843 9.25328 2.4212 12.4164 3.06236 13.0576C3.38312 13.3784 5.11006 13.1972 7.03406 12.8721C6.93911 14.0457 7.32184 15.1959 8.36558 16.2397C9.40932 17.2834 10.5596 17.6661 11.7331 17.5712C11.4081 19.4952 11.2268 21.2222 11.5476 21.543C12.1887 22.1841 15.352 17.721 15.8767 15.5158ZM17.9115 8.10794C17.521 8.49844 16.8878 8.49844 16.4973 8.10794C16.1068 7.71745 16.1068 7.08423 16.4973 6.69373C16.8878 6.30323 17.521 6.30323 17.9115 6.69373C18.302 7.08423 18.302 7.71745 17.9115 8.10794Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.76938 20.8359C4.55038 21.6169 7.23094 20.2027 8.01202 19.4217C8.79311 18.6406 8.79302 17.3742 8.01202 16.5932C7.23103 15.8122 5.96468 15.8121 5.1836 16.5932C4.40252 17.3743 2.98839 20.0549 3.76938 20.8359Z",
                fill: "currentColor"
            })
        ]
    });
}


/***/ }),

/***/ 36651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ DocsFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 3 modules
var dist_index_esm = __webpack_require__(66479);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/next-plausible/dist/index.esm.js
var next_plausible_dist_index_esm = __webpack_require__(5017);
;// CONCATENATED MODULE: ./hooks/use-plausible.ts
// Use this hook to trigger Plausible events.
// The function is called in the following format:
// const plausible = usePlausible();
// plausible('Was this helpful? (Yes)', {
//   props: {
//     Page: 'page_slug',
//   },
// })

// eslint-disable-next-line
function usePlausible() {
    return (0,next_plausible_dist_index_esm/* usePlausible */.wW)();
}

// EXTERNAL MODULE: ./components/docs/layout/sidenav.tsx
var sidenav = __webpack_require__(32596);
;// CONCATENATED MODULE: ./components/docs/layout/footer.tsx





function CustomButtom(param) {
    let { ctaText , handleClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Button */.zx, {
        variant: "ghost",
        border: "1px solid",
        borderColor: "var(--borderColor)",
        color: "var(--primaryTextColor)",
        flex: 1,
        size: "sm",
        fontWeight: "regular",
        mr: 4,
        h: 10,
        w: 20,
        onClick: handleClick,
        _hover: {
            bg: "var(--highlightBg)"
        },
        _active: {
            bg: "gray.100"
        },
        children: ctaText
    });
}
function DocsFooter() {
    const plausible = usePlausible();
    const { asPath  } = (0,router.useRouter)();
    const toast = (0,dist_index_esm/* useToast */.pm)();
    const handleFeedbackSuccess = ()=>{
        toast({
            title: "Thank you for your feedback!",
            position: "bottom-left",
            status: "success",
            duration: 3000
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
        as: "footer",
        direction: {
            base: "column",
            md: "row"
        },
        align: {
            base: "flex-start",
            md: "center"
        },
        justify: "space-between",
        bg: "var(--bodyBg)",
        gap: 8,
        pos: "relative",
        borderTop: "1px solid",
        borderColor: "var(--borderColor)",
        px: 6,
        pt: {
            base: 8,
            md: 4
        },
        pb: 4,
        w: {
            base: "full",
            lg: "calc(100vw - ".concat(sidenav/* SIDENAV_WIDTH */.d, ")")
        },
        left: {
            base: 0,
            lg: sidenav/* SIDENAV_WIDTH */.d
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                direction: {
                    base: "column",
                    md: "row"
                },
                align: {
                    base: "flex-start",
                    md: "center"
                },
                gap: 2,
                w: "full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                        color: "var(--primaryTextColor)",
                        textStyle: "sm-medium",
                        mr: 6,
                        children: "Was this helpful?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                        w: {
                            base: "full",
                            sm: "unset"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButtom, {
                                ctaText: "Yes",
                                handleClick: ()=>{
                                    plausible("Was this helpful? (Yes)", {
                                        props: {
                                            Page: asPath
                                        }
                                    });
                                    handleFeedbackSuccess();
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButtom, {
                                ctaText: "No",
                                handleClick: ()=>{
                                    plausible("Was this helpful? (No)", {
                                        props: {
                                            Page: asPath
                                        }
                                    });
                                    handleFeedbackSuccess();
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                textStyle: "sm-normal",
                color: "var(--secondaryTextColor)",
                mr: 6,
                whiteSpace: "nowrap",
                children: [
                    "Clerk \xa9 ",
                    new Date().getUTCFullYear()
                ]
            })
        ]
    });
}


/***/ }),

/***/ 6903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ DOCS_HEADER_HEIGHT; },
  "U": function() { return /* binding */ DocsHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/index.esm.js
var index_esm = __webpack_require__(8395);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/index.esm.js
var select_dist_index_esm = __webpack_require__(57026);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/MenuIcon.js
var MenuIcon = __webpack_require__(30093);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/SearchIcon.js
var SearchIcon = __webpack_require__(69743);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MoonIcon.js
var MoonIcon = __webpack_require__(22173);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/SunIcon.js
var SunIcon = __webpack_require__(35530);
// EXTERNAL MODULE: ./node_modules/react/cjs/react.production.min.js
var react_production_min = __webpack_require__(72408);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 4 modules
var transition_esm = __webpack_require__(35131);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.esm.js + 6 modules
var dialog_esm = __webpack_require__(18346);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/createAutocomplete.js + 26 modules
var createAutocomplete = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/requester/getAlgoliaResults.js + 3 modules
var getAlgoliaResults = __webpack_require__(59870);
// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(70290);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ./components/common/dynamic-hero-icon.tsx
var dynamic_hero_icon = __webpack_require__(77248);
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAlgoliaHitHighlight.js + 2 modules
var parseAlgoliaHitHighlight = __webpack_require__(47334);
;// CONCATENATED MODULE: ./components/docs/search/highlight.js


function Highlight(param) {
    let { hit , attribute , tagName ="mark" , isLightMode  } = param;
    return /*#__PURE__*/ (0,react_production_min.createElement)(react_production_min.Fragment, {}, (0,parseAlgoliaHitHighlight/* parseAlgoliaHitHighlight */.T)({
        hit,
        attribute
    }).map((param, index)=>{
        let { value , isHighlighted  } = param;
        if (isHighlighted) {
            return /*#__PURE__*/ (0,react_production_min.createElement)(tagName, {
                key: index,
                style: {
                    color: isLightMode ? "black" : "white"
                }
            }, value);
        }
        return value;
    }));
}
/* harmony default export */ var highlight = (Highlight);

;// CONCATENATED MODULE: ./components/docs/search/result-panel.js





function ResultPanel(param) {
    let { autocomplete , autocompleteState , panelRef , onResultClick , isLightMode  } = param;
    var ref;
    const [collection] = autocompleteState.collections;
    const count = collection === null || collection === void 0 ? void 0 : (ref = collection.items) === null || ref === void 0 ? void 0 : ref.length;
    const height = count * 135 + 50; // Dynamic height based on item count
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative w-[600px]",
        style: {
            height
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: panelRef,
            className: [
                "aa-Panel",
                "aa-Panel--desktop",
                autocompleteState.status === "stalled" && "aa-Panel--stalled",
                isLightMode ? "!bg-white" : "!bg-gray-800 !shadow-none !border !border-gray-600"
            ].filter(Boolean).join(" "),
            ...autocomplete.getPanelProps({}),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aa-PanelLayout aa-Panel--scrollable",
                children: autocompleteState.collections.map((collection, index)=>{
                    const { source , items  } = collection;
                    const docs = items.filter((item)=>item.type == "doc");
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: " aa-Source",
                        children: docs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: " aa-List",
                            ...autocomplete.getListProps(),
                            children: docs.map((item, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: classnames_default()("aa-Item", "w-[80vw] md:w-[58vw] lg:w-[570px] h-auto py-4", isLightMode ? "hover:!bg-gray-100" : "hover:!bg-gray-900", index !== docs.length - 1 && "border-solid border-b-2 border-gray-100"),
                                    ...autocomplete.getItemProps({
                                        item,
                                        source
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        legacyBehavior: true,
                                        href: item.slug,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "aa-ItemWrapper",
                                            onClick: onResultClick,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "aa-ItemContent",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        classNames: ("aa-ItemContentBody", "w-[80vw]"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: classnames_default()("aa-ItemContentTitle", isLightMode ? "!text-gray-900" : "!text-gray-100"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(highlight, {
                                                                    hit: item,
                                                                    attribute: "title",
                                                                    isLightMode: isLightMode
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: classnames_default()("aa-ItemContentDescription", isLightMode ? "!text-gray-900" : "!text-gray-200"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(highlight, {
                                                                    hit: item,
                                                                    attribute: "description",
                                                                    isLightMode: isLightMode
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classnames_default()("aa-ItemContentDescription max-h-16 mt-2 overflow-hidden", isLightMode ? "!text-gray-900" : "!text-gray-200"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(highlight, {
                                                                        hit: item,
                                                                        attribute: "body",
                                                                        isLightMode: isLightMode
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "..."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "aa-ItemActions",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly",
                                                        type: "button",
                                                        title: "Select",
                                                        style: {
                                                            pointerEvents: "none"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            className: isLightMode ? "!fill-gray-500" : "!fill-gray-100",
                                                            viewBox: "0 0 24 24",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, item.objectID);
                            })
                        })
                    }, "source-".concat(index));
                })
            })
        })
    });
}
/* harmony default export */ var result_panel = (ResultPanel);

// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-theme-classic/dist/theme.min.css
var theme_min = __webpack_require__(54249);
;// CONCATENATED MODULE: ./components/docs/search/autocomplete.js









const searchClient = algoliasearch_lite_umd_default()("RA7W9NZP4T", "52385d30a5ca4460564defe5b2d0ffb1");
function Autocomplete(props) {
    const initialState = {
        collections: [],
        completion: null,
        context: {},
        isOpen: false,
        query: "",
        activeItemId: null,
        status: "idle"
    };
    const { isLightMode  } = props;
    const [autocompleteState, setAutocompleteState] = react.useState(initialState);
    const [activeItem, setActiveItem] = react.useState(null);
    const inputRef = react.useRef(null);
    const formRef = react.useRef(null);
    const panelRef = react.useRef(null);
    const autocomplete = react.useMemo(()=>(0,createAutocomplete/* createAutocomplete */.l)({
            onStateChange (param) {
                let { state  } = param;
                setAutocompleteState(state);
            },
            getSources () {
                return [
                    {
                        sourceId: "links",
                        getItems (param) {
                            let { query  } = param;
                            return (0,getAlgoliaResults/* getAlgoliaResults */.g)({
                                searchClient,
                                queries: [
                                    {
                                        indexName: "prod_sanity",
                                        query,
                                        params: {
                                            hitsPerPage: 5
                                        }
                                    }
                                ]
                            });
                        },
                        getItemUrl (param) {
                            let { item  } = param;
                            return item.slug;
                        }
                    }
                ];
            },
            ...props
        }), [
        props
    ]);
    const { getEnvironmentProps  } = autocomplete;
    const handleResultClick = ()=>{
        // Set active item ID as string
        const { activeItemId  } = autocompleteState;
        if (activeItemId === 0 || activeItemId) {
            setActiveItem(activeItemId.toString());
        }
    };
    react.useEffect(()=>{
        if (!formRef.current || !panelRef.current || !inputRef.current) {
            return undefined;
        }
        const { onTouchStart , onTouchMove  } = getEnvironmentProps({
            formElement: formRef.current,
            inputElement: inputRef.current,
            panelElement: panelRef.current
        });
        window.addEventListener("touchstart", onTouchStart);
        window.addEventListener("touchmove", onTouchMove);
        return ()=>{
            window.removeEventListener("touchstart", onTouchStart);
            window.removeEventListener("touchmove", onTouchMove);
        };
    }, [
        getEnvironmentProps,
        formRef,
        inputRef,
        panelRef
    ]);
    const bg = isLightMode ? "!bg-white" : "!bg-gray-900";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "aa-Autocomplete",
        ...autocomplete.getRootProps({}),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                ref: formRef,
                className: classnames_default()("aa-Form", isLightMode ? "focus-within:!border-clerk-blue" : "!border-gray-600 focus-within:!border-clerk-blue-hover"),
                ...autocomplete.getFormProps({
                    inputElement: inputRef.current
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("aa-InputWrapperPrefix", bg),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: "aa-Label",
                            ...autocomplete.getLabelProps({}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "flex items-center aa-SubmitButton",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamic_hero_icon/* DynamicHeroIcon */.Y, {
                                    icon: "SearchIcon",
                                    className: classnames_default()("w-5 h-5", isLightMode ? "fill-clerk-blue" : "fill-clerk-blue-hover")
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "aa-InputWrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: classnames_default()("aa-Input disabled:text-gray-400 disabled:cursor-wait", bg, isLightMode ? "!text-gray-90" : "!text-gray-100 !placeholder:text-gray-400"),
                            ref: inputRef,
                            disabled: Boolean(activeItem),
                            ...autocomplete.getInputProps({
                                inputElement: inputRef.current
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("aa-InputWrapperSuffix", bg),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: classnames_default()("aa-ClearButton", isLightMode ? "hover:!fill-black" : "hover:!text-clerk-blue"),
                            title: "Clear",
                            type: "button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamic_hero_icon/* DynamicHeroIcon */.Y, {
                                icon: "XIcon",
                                className: "w-5 h-5"
                            })
                        })
                    })
                ]
            }),
            activeItem ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                role: "status",
                className: "my-10 mx-auto w-16 h-16 text-gray-200 fill-[#3e34d3] animate-spin",
                viewBox: "0 0 100 101",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                        fill: "currentFill"
                    })
                ]
            }) : null,
            autocompleteState.isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(result_panel, {
                autocomplete: autocomplete,
                autocompleteState: autocompleteState,
                panelRef: panelRef,
                onResultClick: handleResultClick,
                isLightMode: isLightMode
            })
        ]
    });
}
/* harmony default export */ var autocomplete = (Autocomplete);

;// CONCATENATED MODULE: ./components/docs/search/search-modal.js






function SearchModal(param) {
    let { show , hideModal , isLightMode  } = param;
    const router = (0,next_router.useRouter)();
    const cancelButtonRef = (0,react_production_min.useRef)(null);
    (0,react_production_min.useEffect)(()=>{
        const handleRouteChange = (url, param)=>{
            let { shallow  } = param;
            if (show) {
                hideModal();
            }
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        // If the component is unmounted, unsubscribe
        // from the event with the `off` method:
        return ()=>{
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events,
        show,
        hideModal
    ]);
    if (!show) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Root */.u.Root, {
        show: show,
        as: react_production_min.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog */.V, {
            as: "div",
            className: "fixed inset-0 overflow-y-auto z-[99999]",
            onClose: hideModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-start justify-center min-h-screen px-4 mt-40 text-center sm:mt-0 sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
                        as: react_production_min.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog.Overlay */.V.Overlay, {
                            className: classnames_default()("fixed inset-0 transition-opacity bg-opacity-75", isLightMode ? "bg-gray-500" : "bg-gray-900")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "​"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
                        as: react_production_min.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("relative inline-block align-bottom rounded-lg text-left overflow-x-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-[650px] ", isLightMode ? "bg-white" : "bg-gray-800"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("px-4 pt-5 pb-4 sm:p-6 sm:pb-4", isLightMode ? "bg-white" : "bg-gray-800"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(autocomplete, {
                                        placeholder: "Search the docs...",
                                        autoFocus: true,
                                        isLightMode: isLightMode
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse", isLightMode ? "bg-gray-50" : "bg-gray-800"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: classnames_default()("inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium border rounded-md shadow-sm  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm uppercase", isLightMode ? "text-gray-700 bg-white hover:bg-gray-50 border-gray-300" : "text-gray-300 bg-gray-900 hover:bg-gray-900 border-gray-800"),
                                        onClick: hideModal,
                                        ref: cancelButtonRef,
                                        children: "Cancel"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var search_modal = ((/* unused pure expression or super */ null && (SearchModal)));

// EXTERNAL MODULE: ./components/common/clerk-docs-logo.tsx
var clerk_docs_logo = __webpack_require__(39425);
// EXTERNAL MODULE: ./components/docs/layout/sidenav.tsx
var sidenav = __webpack_require__(32596);
;// CONCATENATED MODULE: ./hooks/use-detect-os.ts

function useDetectOS() {
    const [os, setOS] = react.useState(null);
    react.useEffect(()=>{
        if (__webpack_require__.g === null || __webpack_require__.g === void 0 ? void 0 : __webpack_require__.g.window) {
            // @ts-ignore
            if (window.navigator.userAgentData) {
                // @ts-ignore
                const { platform  } = window.navigator.userAgentData;
                if (platform === "macOS") {
                    setOS("macOS");
                } else {
                    setOS("Other");
                }
            } else {
                window.navigator.userAgent.indexOf("Mac") != -1 ? setOS("macOS") : setOS("Other");
            }
        }
    }, []);
    return {
        os,
        isMacOS: os === "macOS"
    };
}

// EXTERNAL MODULE: ./lib/constants.ts
var constants = __webpack_require__(58038);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/XIcon.js
var XIcon = __webpack_require__(68163);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(85858);
// EXTERNAL MODULE: ./components/docs/layout/navigation-content.tsx + 4 modules
var navigation_content = __webpack_require__(62207);
// EXTERNAL MODULE: ./hooks/use-toggle-intercom.ts
var use_toggle_intercom = __webpack_require__(87975);
;// CONCATENATED MODULE: ./components/docs/layout/mobile-menu.tsx








function MobileMenu(param) {
    let { isOpen , onClose , navigation  } = param;
    const isMobileHeaderVisible = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
        base: true,
        lg: false
    });
    react.useEffect(()=>{
        // In case the mobile menu is open and the screen is resized to desktop viewport (Chakra's `lg` breakpoint):
        // 1. Close menu
        // 2. `useEffect` below will re-run
        // 3. Add `overflowY = 'auto'` to `body`
        if (isOpen && !isMobileHeaderVisible) {
            onClose();
        }
    }, [
        isMobileHeaderVisible,
        isOpen,
        onClose
    ]);
    (0,use_toggle_intercom/* useToggleIntercom */.E)({
        shouldBeVisible: !isOpen
    });
    react.useEffect(()=>{
        if (isOpen) {
            document.body.style.overflowY = "hidden";
        } else {
            document.body.style.overflowY = "auto";
        }
        return ()=>{
            document.body.style.overflowY = "auto";
        };
    }, [
        isOpen,
        isMobileHeaderVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            transition: {
                duration: 0.1
            },
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                direction: "column",
                w: "100%",
                bg: "var(--bodyBg)",
                minH: "100vh",
                overflow: "hidden",
                pos: "absolute",
                top: 0,
                left: 0,
                zIndex: "modal",
                px: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                        align: "center",
                        justify: "space-between",
                        py: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(clerk_docs_logo/* ClerkDocsLogo */.s, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                "aria-label": "Close menu",
                                color: "gray.400",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                    height: "100%"
                                }),
                                boxSize: 6,
                                size: "xs",
                                variant: "ghost",
                                _hover: {
                                    bgColor: "unset",
                                    color: "gray.500"
                                },
                                _active: {
                                    bgColor: "unset"
                                },
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                        flex: 1,
                        pt: 4,
                        pb: 10,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_content/* NavigationContent */.i, {
                            navigation: navigation,
                            isMobileMenuOpen: isOpen,
                            closeMobileMenu: onClose
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@clerk/nextjs/dist/index.js
var dist = __webpack_require__(16855);
// EXTERNAL MODULE: ./context/app-and-instance-switcher.tsx
var app_and_instance_switcher = __webpack_require__(93376);
// EXTERNAL MODULE: ./pages/index.tsx + 31 modules
var pages = __webpack_require__(16263);
// EXTERNAL MODULE: ./context/docs-banner.js
var docs_banner = __webpack_require__(77941);
;// CONCATENATED MODULE: ./components/docs/layout/header.tsx
















const DOCS_HEADER_HEIGHT = {
    base: "70px"
};
const instancesOrder = [
    "development",
    "production"
];
function DocsHeader(param) {
    let { navigation  } = param;
    const router = (0,next_router.useRouter)();
    const { isMacOS  } = useDetectOS();
    const { colorMode , toggleColorMode  } = (0,index_esm/* useColorMode */.If)();
    const [showSearch, showSearchOverlay] = react.useState(false);
    const { isOpen , onClose , onOpen  } = (0,dist_index_esm/* useDisclosure */.qY)();
    const { apps , currentApp , setCurrentApp , currentInstance , setCurrentInstance  } = react.useContext(app_and_instance_switcher/* AppAndInstanceSwitcherContext */.X);
    const [showBanner, setShowBanner] = (0,docs_banner/* useBannerContext */.n)();
    const showKeysSelector = apps && currentApp && currentInstance;
    react.useEffect(()=>{
        const handleSearchShortcut = (event)=>{
            const { key , ctrlKey , metaKey  } = event;
            const isKPressed = key === "k";
            const isModifierPressed = isMacOS ? metaKey : ctrlKey;
            if (isKPressed && isModifierPressed) {
                event.preventDefault(); // Prevents focus going to address bar on Windows
                showSearchOverlay(true);
            }
        };
        document.addEventListener("keydown", handleSearchShortcut);
        return ()=>{
            document.removeEventListener("keydown", handleSearchShortcut);
        };
    }, [
        isMacOS
    ]);
    const handleHideBanner = ()=>{
        setShowBanner(false);
    };
    const clerkDomain = "clerkstage.dev" || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal, {
                show: showSearch,
                hideModal: ()=>showSearchOverlay(false),
                isLightMode: colorMode === "light"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                as: "header",
                pos: "fixed",
                borderBottom: "1px solid",
                borderColor: "var(--borderColor)",
                bg: "var(--bodyBg)",
                h: {
                    base: DOCS_HEADER_HEIGHT.base
                },
                w: {
                    base: "full",
                    lg: "calc(100vw - ".concat(sidenav/* SIDENAV_WIDTH */.d, ")")
                },
                top: "0",
                left: {
                    base: 0,
                    lg: sidenav/* SIDENAV_WIDTH */.d
                },
                px: 6,
                zIndex: 999,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu, {
                        isOpen: isOpen,
                        onClose: onClose,
                        navigation: navigation
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                        display: {
                            base: "inline-flex",
                            lg: "none"
                        },
                        align: "center",
                        justify: "space-between",
                        w: "full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(clerk_docs_logo/* ClerkDocsLogo */.s, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                size: "xs",
                                color: "gray.400",
                                "aria-label": "Open menu",
                                variant: "ghost",
                                onClick: onOpen,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon/* default */.Z, {
                                    height: "100%"
                                }),
                                boxSize: 6,
                                _hover: {
                                    bgColor: "unset",
                                    color: "gray.500"
                                },
                                _active: {
                                    bgColor: "unset"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                        display: {
                            base: "none",
                            lg: "flex"
                        },
                        justify: "space-between",
                        align: "center",
                        w: "full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        variant: "outline",
                                        borderColor: "var(--borderColor)",
                                        boxSize: 10,
                                        onClick: toggleColorMode,
                                        role: "group",
                                        _hover: {
                                            bg: "var(--highlightBg)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                            as: colorMode === "light" ? MoonIcon/* default */.Z : SunIcon/* default */.Z,
                                            boxSize: 5,
                                            color: "var(--iconColor)",
                                            transition: "color 0.2s",
                                            _groupHover: {
                                                color: "var(--secondaryBlue)"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        variant: "outline",
                                        borderColor: "var(--borderColor)",
                                        display: {
                                            base: showKeysSelector ? "flex" : "none",
                                            xl: "none"
                                        },
                                        boxSize: 10,
                                        onClick: ()=>showSearchOverlay(true),
                                        role: "group",
                                        _hover: {
                                            bg: "var(--highlightBg)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                            as: SearchIcon/* default */.Z,
                                            boxSize: 5,
                                            color: "var(--iconColor)",
                                            transition: "color 0.2s",
                                            _groupHover: {
                                                color: "var(--secondaryBlue)"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_dist_index_esm/* InputGroup */.BZ, {
                                        w: 56,
                                        h: 10,
                                        display: {
                                            base: showKeysSelector ? "none" : "flex",
                                            xl: "flex"
                                        },
                                        onClick: ()=>showSearchOverlay(true),
                                        cursor: "pointer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* InputLeftElement */.Z8, {
                                                pointerEvents: "none",
                                                h: "inherit",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                    as: SearchIcon/* default */.Z,
                                                    boxSize: "4",
                                                    color: "gray.400"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                placeholder: "Search docs",
                                                variant: "outline",
                                                h: "inherit",
                                                pr: 20,
                                                pointerEvents: "none",
                                                _placeholder: {
                                                    color: "var(--secondaryTextColor)"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_dist_index_esm/* InputRightElement */.xH, {
                                                pointerEvents: "none",
                                                px: 10,
                                                h: "inherit",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Kbd */.Tz, {
                                                        color: "var(--secondaryTextColor)",
                                                        borderColor: "var(--secondaryTextColor)",
                                                        children: isMacOS ? "⌘" : "Ctrl"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        as: "span",
                                                        color: "var(--secondaryTextColor)",
                                                        fontWeight: "medium",
                                                        px: 0.5,
                                                        pos: "relative",
                                                        top: "-0.5",
                                                        children: "+"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Kbd */.Tz, {
                                                        color: "var(--secondaryTextColor)",
                                                        borderColor: "var(--secondaryTextColor)",
                                                        children: "K"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    showKeysSelector && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_dist_index_esm/* Select */.Ph, {
                                                color: "var(--primaryTextColor)",
                                                defaultValue: currentApp.application_name,
                                                onChange: (e)=>{
                                                    const app = apps.find((param)=>{
                                                        let { application_name  } = param;
                                                        return application_name === e.target.value;
                                                    });
                                                    setCurrentApp(app);
                                                },
                                                rootProps: {
                                                    w: "120px",
                                                    sx: {
                                                        "@media(min-width: 1100px)": {
                                                            w: "170px"
                                                        }
                                                    }
                                                },
                                                children: apps.map((param)=>/*#__PURE__*/ {
                                                    let { application_id , application_name  } = param;
                                                    return (0,jsx_runtime.jsx)("option", {
                                                        value: application_name,
                                                        children: application_name
                                                    }, application_id);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_dist_index_esm/* Select */.Ph, {
                                                color: "var(--primaryTextColor)",
                                                defaultValue: currentInstance.environment_type,
                                                onChange: (e)=>{
                                                    const currentInstance = currentApp.instances.find((param)=>{
                                                        let { environment_type  } = param;
                                                        return environment_type === e.target.value;
                                                    });
                                                    setCurrentInstance(currentInstance);
                                                },
                                                rootProps: {
                                                    w: "120px",
                                                    sx: {
                                                        "@media(min-width: 1100px)": {
                                                            w: "170px"
                                                        }
                                                    }
                                                },
                                                children: currentApp.instances.sort((a, b)=>{
                                                    return instancesOrder.indexOf(a["environment_type"]) - instancesOrder.indexOf(b["environment_type"]);
                                                }).map((param)=>/*#__PURE__*/ {
                                                    let { instance_id , environment_type  } = param;
                                                    return (0,jsx_runtime.jsx)("option", {
                                                        value: environment_type,
                                                        children: environment_type.charAt(0).toUpperCase() + environment_type.slice(1)
                                                    }, instance_id);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                                align: "center",
                                gap: 4,
                                marginRight: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        legacyBehavior: true,
                                        href: constants/* URLS.home */.ns.home,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                                            as: "a",
                                            textStyle: "sm-medium",
                                            color: "var(--secondaryBlue)",
                                            onClick: ()=>{
                                                pages.analytics.track("Docs_Header_Go to Clerk.com Button Clicked", {
                                                    surface: "Docs",
                                                    location: "Header",
                                                    page: router.pathname
                                                });
                                                (0,pages.rudderTrack)("Docs_Header_Go to Clerk.com Button Clicked", {
                                                    surface: "Docs",
                                                    location: "Header",
                                                    page: router.pathname
                                                });
                                            },
                                            children: [
                                                "Go to ",
                                                clerkDomain
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SignedOut, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            legacyBehavior: true,
                                            href: "https://dashboard.clerkstage.dev" + "/sign-up",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                as: layout_dist_index_esm/* Link */.rU,
                                                variant: "blue",
                                                isExternal: true,
                                                ml: 4,
                                                border: "1px",
                                                borderColor: "transparent",
                                                className: "hover:bg-blue-700",
                                                onClick: ()=>{
                                                    pages.analytics.track("Docs_Header_Sign up Clicked", {
                                                        surface: "Docs",
                                                        location: "Header",
                                                        page: router.pathname
                                                    });
                                                    (0,pages.rudderTrack)("Docs_Header_Sign up Clicked", {
                                                        surface: "Docs",
                                                        location: "Header",
                                                        page: router.pathname
                                                    });
                                                },
                                                children: "Sign up"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SignedIn, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            legacyBehavior: true,
                                            href: "https://dashboard.clerkstage.dev",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                as: layout_dist_index_esm/* Link */.rU,
                                                variant: "blue",
                                                isExternal: true,
                                                ml: 4,
                                                border: "1px",
                                                borderColor: "transparent",
                                                className: "hover:bg-blue-700",
                                                onClick: ()=>{
                                                    pages.analytics.track("Docs_Header_Dashboard Clicked", {
                                                        surface: "Docs",
                                                        location: "Header",
                                                        page: router.pathname
                                                    });
                                                    (0,pages.rudderTrack)("Docs_Header_Dashboard Clicked", {
                                                        surface: "Docs",
                                                        location: "Header",
                                                        page: router.pathname
                                                    });
                                                },
                                                children: "Dashboard"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 62207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ NavigationContent; }
});

// UNUSED EXPORTS: SIDENAV_WIDTH

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/HomeIcon.js
var HomeIcon = __webpack_require__(25575);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/LightningBoltIcon.js
var LightningBoltIcon = __webpack_require__(96618);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/UserIcon.js
var UserIcon = __webpack_require__(60364);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/UserGroupIcon.js
var UserGroupIcon = __webpack_require__(18302);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/TemplateIcon.js
var TemplateIcon = __webpack_require__(8144);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/TerminalIcon.js
var TerminalIcon = __webpack_require__(27523);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/PuzzleIcon.js
var PuzzleIcon = __webpack_require__(46450);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/LockClosedIcon.js
var LockClosedIcon = __webpack_require__(81516);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/SupportIcon.js
var SupportIcon = __webpack_require__(11223);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowCircleUpIcon.js
var ArrowCircleUpIcon = __webpack_require__(91698);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/BeakerIcon.js
var BeakerIcon = __webpack_require__(12981);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ColorSwatchIcon.js
var ColorSwatchIcon = __webpack_require__(51304);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/QuestionMarkCircleIcon.js
var QuestionMarkCircleIcon = __webpack_require__(2905);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowLeftIcon.js
var ArrowLeftIcon = __webpack_require__(93973);
;// CONCATENATED MODULE: ./components/docs/icons/NextjsIcon.tsx


function NextjsIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 256 256",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "svgIDc",
                        x1: "55.633%",
                        x2: "83.228%",
                        y1: "56.385%",
                        y2: "96.08%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#FFF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#FFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "svgIDd",
                        x1: "50%",
                        x2: "49.953%",
                        y1: "0%",
                        y2: "73.438%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#FFF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#FFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        id: "svgIDa",
                        cx: "128",
                        cy: "128",
                        r: "128"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "svgIDb",
                fill: "#fff",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                    href: "#svgIDa"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                mask: "url(#svgIDb)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "128",
                        cy: "128",
                        r: "128"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#svgIDc)",
                        d: "M212.634 224.028L98.335 76.8H76.8v102.357h17.228V98.68L199.11 234.446a128.433 128.433 0 0 0 13.524-10.418Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#svgIDd)",
                        d: "M163.556 76.8h17.067v102.4h-17.067z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var icons_NextjsIcon = ((/* unused pure expression or super */ null && (NextjsIcon)));

;// CONCATENATED MODULE: ./components/common/icons/sign-in.js

function SignInIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17 17C16.4477 17 16 16.5523 16 16L16 4C16 3.44772 16.4477 3 17 3C17.5523 3 18 3.44772 18 4L18 16C18 16.5523 17.5523 17 17 17ZM9.29289 13.7071C8.90237 13.3166 8.90237 12.6834 9.29289 12.2929L10.5858 11L3 11C2.44772 11 2 10.5523 2 10C2 9.44772 2.44772 9 3 9L10.5858 9L9.29289 7.70711C8.90237 7.31658 8.90237 6.68342 9.29289 6.29289C9.68342 5.90237 10.3166 5.90237 10.7071 6.29289L13.7071 9.29289C13.8946 9.48043 14 9.73478 14 10C14 10.2652 13.8946 10.5196 13.7071 10.7071L10.7071 13.7071C10.3166 14.0976 9.68342 14.0976 9.29289 13.7071Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/common/icons/request-auth.js

function RequestAuthIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.5 9.5V8.5C7.5 7.11929 8.61929 6 10 6C11.3807 6 12.5 7.11929 12.5 8.5V9.5C13.0523 9.5 13.5 9.94772 13.5 10.5V13C13.5 13.5523 13.0523 14 12.5 14H7.5C6.94772 14 6.5 13.5523 6.5 13V10.5C6.5 9.94772 6.94772 9.5 7.5 9.5ZM11.5 8.5V9.5H8.5V8.5C8.5 7.67157 9.17157 7 10 7C10.8284 7 11.5 7.67157 11.5 8.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3414 3.61414C14.7147 1.99827 12.4736 1 9.99963 1C5.02942 1 1 5.02942 1 10C1 14.9706 5.02942 19 9.99963 19C12.4871 19 14.7391 17.9908 16.368 16.3593C16.368 16.3593 16.8851 15.7788 16.368 15.2541C15.8505 14.7297 15.2598 15.2541 15.2598 15.2541C13.914 16.6014 12.0543 17.4347 9.99954 17.4347C5.89372 17.4347 2.56518 14.1062 2.56518 10C2.56518 5.89381 5.89372 2.56528 9.99954 2.56528C12.0415 2.56528 13.8911 3.38848 15.2346 4.72085L13.9324 6.02303C13.6256 6.32983 13.7319 6.57548 14.1657 6.57548H17.2897C18.0754 6.57548 18.0754 6.57548 18.0754 5.78975V2.66581C18.0754 2.2331 17.8283 2.1272 17.5229 2.43254L16.3414 3.61414Z",
                fill: "currentColor"
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/common/icons/rocket.js
var rocket = __webpack_require__(34507);
// EXTERNAL MODULE: ./lib/constants.ts
var constants = __webpack_require__(58038);
// EXTERNAL MODULE: ./context/docs-navigation.tsx
var docs_navigation = __webpack_require__(50463);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ExternalLinkIcon.js
var ExternalLinkIcon = __webpack_require__(84563);
;// CONCATENATED MODULE: ./components/docs/layout/sidenav-item.tsx



function SidenavItem(param) {
    let { isActive =false , isExternal =false , icon , text , size ="md" , handleClick =()=>{
    /* noop */ }  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        align: "center",
        px: 4,
        py: 2,
        rounded: "md",
        cursor: "pointer",
        gap: 4,
        bg: isActive ? "var(--highlightBg)" : "transparent",
        color: isActive ? "var(--primaryTextColor)" : "var(--secondaryTextColor)",
        onClick: handleClick,
        transition: "all 0.2s",
        role: "group",
        _hover: {
            color: "var(--primaryTextColor)"
        },
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                as: icon,
                transition: "all 0.2s",
                color: isActive ? "var(--primaryTextColor)" : "var(--iconColor)",
                _groupHover: {
                    color: "var(--primaryTextColor)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                align: "center",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        pl: icon ? 0 : 8,
                        textStyle: size === "sm" ? "xs-medium" : "sm-medium",
                        children: text
                    }),
                    isExternal && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                        as: ExternalLinkIcon/* default */.Z
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/docs/layout/navigation-content.tsx











const SIDENAV_WIDTH = "300px";
function getCategory(slug) {
    return slug.split("/")[2] || "home";
}
function getIconByCategory(category) {
    switch(category){
        case constants/* DOCS_CATEGORIES.home */.vR.home:
            return HomeIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.nextjs */.vR.nextjs:
            return NextjsIcon;
        case constants/* DOCS_CATEGORIES.quickstarts */.vR.quickstarts:
            return LightningBoltIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.authentication */.vR.authentication:
            return SignInIcon;
        case constants/* DOCS_CATEGORIES.requestAuthentication */.vR.requestAuthentication:
            return RequestAuthIcon;
        case constants/* DOCS_CATEGORIES.users */.vR.users:
            return UserIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.organizations */.vR.organizations:
            return UserGroupIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.componentReference */.vR.componentReference:
            return TemplateIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.apiReference */.vR.apiReference:
            return TerminalIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.integrations */.vR.integrations:
            return PuzzleIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.deployments */.vR.deployments:
            return rocket/* RocketIcon */.W;
        case constants/* DOCS_CATEGORIES.security */.vR.security:
            return LockClosedIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.troubleshooting */.vR.troubleshooting:
            return SupportIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.upgrading */.vR.upgrading:
            return ArrowCircleUpIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.testing */.vR.testing:
            return BeakerIcon/* default */.Z;
        case constants/* DOCS_CATEGORIES.componentCustomization */.vR.componentCustomization:
            return ColorSwatchIcon/* default */.Z;
        default:
            return QuestionMarkCircleIcon/* default */.Z;
    }
}
function getNavByCategory(navigation, category) {
    const navObject = navigation.reduce((acc, cur)=>{
        acc[cur.navId] = cur;
        return acc;
    }, {});
    // Mapping needed when category slug doesn't match navId from Sanity
    // (e.g. /docs/integration/:page and navId: "docs-integrations")
    switch(category){
        case "":
            return navObject["docs-home"];
        case constants/* DOCS_CATEGORIES.requestAuthentication */.vR.requestAuthentication:
            return navObject["docs-request-auth"];
        case constants/* DOCS_CATEGORIES.apiReference */.vR.apiReference:
            return navObject["docs-api-sdk"];
        case constants/* DOCS_CATEGORIES.integrations */.vR.integrations:
            return navObject["docs-integrations"];
        case constants/* DOCS_CATEGORIES.nextjs */.vR.nextjs:
            return navObject["docs-nextjs"];
        default:
            return navObject["docs-".concat(category.toLowerCase())];
    }
}
function NavigationContent(param) {
    let { navigation , isMobileMenuOpen , closeMobileMenu =()=>{
    /* noop */ }  } = param;
    var ref, ref1;
    // TODO: Move this to the route's layout once Next releases it
    const { currentView , setCurrentView , resetCurrentView  } = react.useContext(docs_navigation/* DocsNavigationContext */._);
    const { asPath  } = (0,router.useRouter)();
    const activePath = asPath.replace(/#.*/, ""); // Remove hash fragment
    react.useEffect(()=>{
        const isHome = activePath === "/docs";
        const shouldUpdateSidenav = (currentView === null || currentView === void 0 ? void 0 : currentView.slug) !== activePath;
        if (shouldUpdateSidenav) {
            if (isHome) {
                resetCurrentView();
            } else {
                const category = getCategory(activePath);
                const sideNav = getNavByCategory(navigation, category);
                if (!sideNav) return;
                const { name , categories  } = sideNav;
                if (name === "Docs Home") return;
                setCurrentView({
                    view: "children",
                    name: name,
                    slug: activePath,
                    categories: categories,
                    icon: getIconByCategory(category)
                });
            }
        }
    // Only check on page changes to avoid an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activePath
    ]);
    const homeNavigation = ((ref = navigation.find((param)=>{
        let { navId  } = param;
        return navId === "docs-home";
    })) === null || ref === void 0 ? void 0 : ref.categories[0].links) || [];
    const handleCloseMobileMenu = ()=>{
        if (isMobileMenuOpen) {
            closeMobileMenu();
        }
    };
    // const handleClick = (title: string) => {
    //   analytics.track(`Docs_Side Nav_Menu Item Clicked`, {
    //     surface: 'Docs',
    //     location: 'Side Nav',
    //     ClickedOn: title
    //   });
    //   rudderTrack(`Docs_Side Nav_Menu Item Clicked`, {
    //     surface: 'Docs',
    //     location: 'Side Nav',
    //     ClickedOn: title
    //   });
    // };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        as: "nav",
        h: {
            base: "auto",
            lg: "full"
        },
        w: "full",
        pos: "relative",
        overflowY: "auto",
        overflowX: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                opacity: (currentView === null || currentView === void 0 ? void 0 : currentView.view) === "parents" ? 1 : 0,
                position: "absolute",
                top: "0",
                transform: "translateX(".concat((currentView === null || currentView === void 0 ? void 0 : currentView.view) === "parents" ? 0 : -100, "%)"),
                transition: "all .3s",
                zIndex: (currentView === null || currentView === void 0 ? void 0 : currentView.view) === "parents" ? 1 : 0,
                w: {
                    base: "full",
                    sm: "auto",
                    lg: "full"
                },
                paddingRight: 4,
                pb: {
                    base: 12,
                    lg: 8
                },
                children: homeNavigation.map((param)=>{
                    let { _key , title , slug , url  } = param;
                    const icon = getIconByCategory(getCategory(slug));
                    const href = url || slug;
                    const isExternal = Boolean(url);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        legacyBehavior: true,
                        href: href,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                            isExternal: isExternal,
                            onClick: handleCloseMobileMenu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SidenavItem, {
                                isActive: slug === activePath,
                                isExternal: isExternal,
                                icon: icon,
                                text: title
                            })
                        })
                    }, _key);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                opacity: (currentView === null || currentView === void 0 ? void 0 : currentView.view) === "children" ? 1 : 0,
                position: "absolute",
                top: "0",
                transition: "all .3s",
                transform: "translateX(".concat((currentView === null || currentView === void 0 ? void 0 : currentView.view) === "children" ? 0 : 100, "%)"),
                zIndex: (currentView === null || currentView === void 0 ? void 0 : currentView.view) === "children" ? 1 : 0,
                w: {
                    base: "full",
                    sm: "auto",
                    lg: "full"
                },
                paddingRight: 4,
                pb: {
                    base: 12,
                    lg: 8
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        legacyBehavior: true,
                        href: constants/* DOCS_URLS.home */.Eo.home,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: handleCloseMobileMenu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SidenavItem, {
                                icon: ArrowLeftIcon/* default */.Z,
                                text: "All docs"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        align: "center",
                        gap: 3,
                        px: 3,
                        py: 5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                as: currentView === null || currentView === void 0 ? void 0 : currentView.icon,
                                boxSize: 6,
                                color: "var(--primaryTextColor)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                color: "var(--primaryTextColor)",
                                textStyle: (currentView === null || currentView === void 0 ? void 0 : currentView.name.length) > 20 ? "md" : "lg-medium",
                                children: currentView === null || currentView === void 0 ? void 0 : currentView.name
                            })
                        ]
                    }),
                    currentView === null || currentView === void 0 ? void 0 : (ref1 = currentView.categories) === null || ref1 === void 0 ? void 0 : ref1.map((param)=>/*#__PURE__*/ {
                        let { categoryId , categoryName , links  } = param;
                        return (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                categoryName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    color: "var(--primaryTextColor)",
                                    textStyle: "md-medium",
                                    pb: 1,
                                    pt: 4,
                                    pr: 2,
                                    pl: 12,
                                    children: categoryName
                                }) : null,
                                links.map((param)=>{
                                    let { slug , url , title  } = param;
                                    const href = url || slug;
                                    const isExternal = Boolean(url);
                                    if (!href) return null;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        legacyBehavior: true,
                                        href: href,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                            isExternal: isExternal,
                                            onClick: handleCloseMobileMenu,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SidenavItem, {
                                                isActive: activePath === slug,
                                                isExternal: isExternal,
                                                text: title,
                                                size: "sm"
                                            })
                                        })
                                    }, href);
                                })
                            ]
                        }, categoryId);
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 32596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ SIDENAV_WIDTH; },
/* harmony export */   "x": function() { return /* binding */ DocsSidenav; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _navigation_content__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62207);
/* harmony import */ var _components_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39425);





const SIDENAV_WIDTH = "300px";
function DocsSidenav(param) {
    let { navigation  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        as: "aside",
        pos: "fixed",
        display: {
            base: "none",
            lg: "block"
        },
        h: "100vh",
        w: SIDENAV_WIDTH,
        borderRight: "1px solid",
        borderColor: "var(--borderColor)",
        bg: "var(--bodyBg)",
        paddingLeft: 4,
        paddingTop: 8,
        top: "0",
        overflowY: "auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
            spacing: 0.5,
            h: "full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                    px: 3,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common__WEBPACK_IMPORTED_MODULE_3__/* .ClerkDocsLogo */ .s, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_content__WEBPACK_IMPORTED_MODULE_1__/* .NavigationContent */ .i, {
                    navigation: navigation
                })
            ]
        })
    });
}


/***/ }),

/***/ 29856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ PageContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var _layout_header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6903);
/* harmony import */ var _layout_sidenav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32596);




function PageContainer(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        as: "main",
        pos: "relative",
        pt: {
            base: _layout_header__WEBPACK_IMPORTED_MODULE_1__/* .DOCS_HEADER_HEIGHT.base */ .u.base
        },
        bg: "var(--bodyBg)",
        minH: {
            base: "calc(100vh - ".concat(_layout_header__WEBPACK_IMPORTED_MODULE_1__/* .DOCS_HEADER_HEIGHT.base */ .u.base, ")")
        },
        w: {
            base: "full",
            lg: "calc(100vw - ".concat(_layout_sidenav__WEBPACK_IMPORTED_MODULE_2__/* .SIDENAV_WIDTH */ .d, ")")
        },
        left: {
            base: 0,
            lg: _layout_sidenav__WEBPACK_IMPORTED_MODULE_2__/* .SIDENAV_WIDTH */ .d
        },
        children: children
    });
}


/***/ }),

/***/ 8253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useRouteScroll; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72408);


function useRouteScroll() {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const resetWindowScrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        var // Scroll main content to top on route change
        ref;
        (ref = document.getElementById("main")) === null || ref === void 0 ? void 0 : ref.scrollTo(0, 0);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        router.events.on("routeChangeComplete", resetWindowScrollPosition);
        return ()=>{
            router.events.off("routeChangeComplete", resetWindowScrollPosition);
        };
    }, [
        router.events,
        resetWindowScrollPosition
    ]);
}


/***/ })

}]);